import React, {createContext, useContext, useState} from "react";

import {useHome} from "./HomeContext";
import {useFeedbackTools} from "../../../components/FeedbackTools";
import useDialog from "../../../hooks/useDialog";

const HomeActionContext = createContext();
export const useHomeAction = () => useContext(HomeActionContext);

export default function HomeActionProvider({children}) {

    const {updateHome} = useHome();
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const formEmail = useDialog();
    const formPhone = useDialog();
    const formMobilePhone = useDialog();
    const formCategory = useDialog();
    const formArrivalDay = useDialog();
    const formCirCode = useDialog();
    const formCinCode = useDialog();
    const formCheckIn = useDialog();
    const formCheckOut = useDialog();
    const formVisible = useDialog();
    const formDescriptionIt = useDialog();
    const formDescriptionEn = useDialog();
    const formAddress = useDialog();
    const formName = useDialog();
    const formLocationId = useDialog();

    const apartmentDialog = useDialog();
    const formCreateApartment = useDialog();

    const [selectedApartmentId, setSelectedApartment] = useState(null);

    const handleSubmit = async (formDialog, data) => {
        formDialog.setIsLoading(true)
        try {
            await updateHome(data);
            formDialog.close();
            showSuccessNotification("Aggiornamento effettuato")
        } catch (e) {
            showErrorNotification(e)
        }
        formDialog.setIsLoading(false)
    }

    const handleApartmentSelection = (apartmentId) => {
        setSelectedApartment(apartmentId);
        apartmentDialog.open();
    }

    const context = {
        formEmail,
        formPhone,
        formMobilePhone,
        formCategory,
        formArrivalDay,
        formCheckIn,
        formCheckOut,
        formCirCode,
        formCinCode,
        formVisible,
        formDescriptionIt,
        formDescriptionEn,
        formAddress,
        formName,
        apartmentDialog,
        formCreateApartment,
        formLocationId,
        selectedApartmentId,
        handleSubmit,
        handleApartmentSelection
    }

    return (
        <HomeActionContext.Provider value={context}>
            {children}
        </HomeActionContext.Provider>
    )
}